import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Paper } from "@mui/material";
import { GroupingTable } from "../../../../components/Table/grouping_table";

export const TablaFormatos = ({ rows, copy, del }) => {
  const navigate = useNavigate();
  const sort = {};

  const redirect = (row) => {
    if (row) {
      navigate("/inventarios/etiquetas/" + row.foet_id);
    }
  };
  const columns = [
    {
      accessorKey: "foet_nombre",
      header: "Nombre",
      Cell: ({ row }) =>
        row.original?.foet_nombre ? (
          <span
            onClick={(event) => {
              event.stopPropagation();
              redirect(row.original);
            }}
          >
            {row.original.foet_nombre}
          </span>
        ) : null,
    },
    {
      accessorKey: "foet_descripcion",
      header: "Descripción",
      Cell: ({ row }) =>
        row.original?.foet_descripcion ? (
          <span
            onClick={(event) => {
              event.stopPropagation();
              redirect(row.original);
            }}
          >
            {row.original.foet_descripcion}
          </span>
        ) : null,
    },
    {
      id: "copiar",
      header: "",
      accessorFn: () => "",
      enableSorting: false,
      enableGrouping: false,
      enableColumnFilter: false,
      Cell: ({ row }) =>
        row.original?.foet_id ? (
          <Button
            variant="contained"
            className="btn_system"
            sx={{ width: "120px" }}
            onClick={(event) => {
              event.stopPropagation();
              copy(row.original.foet_id);
            }}
          >
            Copiar
          </Button>
        ) : (
          ""
        ),
    },
    {
      id: "eliminar",
      header: "",
      accessorFn: () => "",
      enableSorting: false,
      enableGrouping: false,
      enableColumnFilter: false,
      Cell: ({ row }) =>
        row.original?.foet_id ? (
          <Button
            variant="contained"
            className="btn_system"
            sx={{ width: "120px" }}
            onClick={(event) => {
              event.stopPropagation();
              del(row.original.foet_id);
            }}
          >
            Eliminar
          </Button>
        ) : (
          ""
        ),
    },
  ];

  return (
    <Paper style={{ height: "75vh", width: "100%" }} sx={{ boxShadow: "none" }}>
      <GroupingTable
        key="tabla_etiquetas"
        columnas={columns}
        data={rows}
        redirect={() => console.log("redirect")}
        sort={sort}
      />
    </Paper>
  );
};
